import Vue from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import router from './router'
import moment from 'moment';

Vue.config.productionTip = false

// put global methods here. Use sparsely!
Vue.mixin({
    methods: {
        fmtDate(val) {
            return moment(val).format('MMM Do');
        }
    }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
